module.exports = __webpack_public_path__ + "media/images/individual-benefit-3-cc6b7b109091272e4ddc3ef1e3819787.svg";